import React, { useEffect, useState } from 'react';
import { Box, Avatar, Typography, IconButton, Tooltip, useMediaQuery, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { IconPower } from '@tabler/icons';

import { useDispatch } from 'react-redux';
import { loginFailureMsg, logout } from 'src/store/auth/UserAuthSlice.jsx';
import { useNavigate } from 'react-router-dom';
import { GetUser } from 'src/hooks/useAuthentication';
import { flush } from 'src/store/auth/userRoleSlice';

export const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = GetUser();

  const [avatarColor, setAvatarColor] = useState('');

  // const user = useSelector((state) => state.UserAuthReducer.user);
  const customizer = useSelector((state) => state.customizer);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const hideMenu = lgUp ? customizer.isCollapse && !customizer.isSidebarHover : '';

  const handleLogout = () => {
    dispatch(logout());
    dispatch(flush());
    localStorage.removeItem('avatarColor');
    dispatch(loginFailureMsg({ message: 'Log Out Successfully' }));
    localStorage.removeItem('postLoginRedirect');
    navigate('/auth/login');
  };

  const getRandomColor = () => {
    // Generate random color in hex format
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };

  const getInitials = (name) => {
    // return name
    //   .split(' ')
    //   .map((part) => part.charAt(0).toUpperCase())
    //   .join('');

    if (!name) return '*';
    return name.trim().charAt(0).toUpperCase();
  };

  useEffect(() => {
    const storedColor = localStorage.getItem('avatarColor');
    if (storedColor) {
      setAvatarColor(storedColor);
    } else {
      const randomColor = getRandomColor();
      setAvatarColor(randomColor);
      localStorage.setItem('avatarColor', randomColor);
    }
  }, []);

  const avatarStyle = (s) => {
    return {
      width: s === 'xs' ? 35 : 95,
      height: s === 'xs' ? 35 : 95,
      fontSize: s === 'xs' ? '20px' : '3.5rem',
      backgroundColor: avatarColor,
      color: '#fff',
    };
  };

  return (
    <>
      {hideMenu ? (
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          sx={{
            mx: 1,
            p: 2,
            // bgcolor: customizer.activeMode === 'light' ? '#fff' : 'secondary.light',
            // boxShadow: '1px 2px 8px #5D87FF',
            transition: 'all 0.5s ease',
          }}
        >
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item>
              <Tooltip title="Logout" placement="top">
                <IconButton
                  color="error"
                  onClick={handleLogout}
                  aria-label="logout"
                  size="large"
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#ff0a54',
                    '&:hover': {
                      // backgroundColor: 'rgba(255, 0, 0, 0.2)',
                    },
                  }}
                >
                  <IconPower size={24} color={`#fff`} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          sx={{
            mx: 1,
            p: 2,
            // bgcolor: customizer.activeMode === 'light' ? '#fff' : 'secondary.light',
            // boxShadow: '1px 2px 8px #5D87FF',
            transition: 'all 0.5s ease',
          }}
        >
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item>
              <Tooltip title="Logout" placement="top">
                <IconButton
                  onClick={handleLogout}
                  aria-label="logout"
                  size="large"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    border: '2px solid #ff0a54',
                    borderRadius: '50px',
                    padding: '8px 16px',
                    color: '#ff0a54',
                    backgroundColor: '#fff',
                    '&:hover': {
                      backgroundColor: '#ff0a54',
                      color: '#fff',
                      borderColor: '#ff0a54',
                    },
                  }}
                >
                  <IconPower size={24} />
                  <span style={{ fontSize: '16px' }}>Logout</span>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        // <Box
        //   display="flex"
        //   alignItems="center"
        //   gap={2}
        //   sx={{
        //     mx: 2,
        //     p: 2,
        //     bgcolor: customizer.activeMode === 'light' ? '#fff' : 'secondary.light',
        //     boxShadow: '1px 2px 8px #5D87FF',
        //     transition: 'all 0.5s ease',
        //   }}
        // >
        //   <Grid container spacing={2}>
        //     <Grid item xs={3}>
        //       <Avatar sx={avatarStyle('xs')}>{user ? getInitials(user.first_name) : ''}</Avatar>
        //     </Grid>
        //     <Grid item xs={6}>
        //       <Box>
        //         <Typography variant="h6" color="textPrimary">
        //           {user ? user.first_name : 'Mathew'}
        //         </Typography>
        //         <Typography variant="caption" color="textSecondary">
        //           {user ? user.role_name : '-'}
        //         </Typography>
        //       </Box>
        //     </Grid>
        //     <Grid item xs={3}>
        //       <Box sx={{ ml: 'auto' }}>
        //         <Tooltip title="Logout" placement="top">
        //           <IconButton color="error" onClick={handleLogout} aria-label="logout" size="large">
        //             <IconPower size={20} />
        //           </IconButton>
        //         </Tooltip>
        //       </Box>
        //     </Grid>
        //   </Grid>
        // </Box>
      )}
    </>
  );
};
